import { defineStore } from 'pinia'
interface StationState {
  id: string // 状态ID，如 "CHECKED"
  code: string // 状态代码，如 "3"
  name: string // 状态名称，如 "已审核"
}

interface IsNewDevice {
  code: string // 设备代码，如 "1"
  id: string // 是否为新设备的ID，如 "NO"
  name: string // 是否为新设备的名称，如 "否"
}

interface StaffType {
  id: string // 类型ID，如 "EMPLOYER"
  code: string // 类型代码，如 "0"
  name: string // 类型名称，如 "站长"
}

interface State {
  id: string // 状态ID，如 "ENABLE"
  code: string // 状态代码，如 "0"
  name: string // 状态名称，如 "启用"
}

interface User {
  stationState: StationState // 站点状态
  areaId: string // 区域ID
  updatePasswordTime: string // 修改密码时间，格式为 "YYYY-MM-DD HH:mm:ss"
  stationName: string // 站点名称
  stationCode: string // 站点编码
  cityId: string // 城市ID
  id: number // 用户ID
  isNewDevice: IsNewDevice // 是否为新设备
  provinceId: string // 省份ID
  principalPhone: string // 负责人电话
  name: string // 用户名称
  token: string // 用户 token
  staffType: StaffType // 员工类型
  stationId: number // 站点ID
  state: State // 用户状态
  phone: string // 用户电话
}
interface UserInfo {
  token: string
  langType: 'cn' | 'en'
  useData: object
}
interface RequestHeaders {
  acceptLanguage: string // 接受的语言，如 "cn"
  deviceName: string // 设备名称，如 "%"
  deviceVersion: string // 设备版本，如 "iOS .1.2"
  deviceModel: string // 设备型号，如 "iPhoax"
  sysCode: string // 系统代码，可能为空
  authToken: string // 授权 token，如 ".1n3ZtuW8wFtJzV235EBcC-PsEIMJWMKLo5t5H7BVrkc"
  appEnv: string // 应用环境，如 "UAT"
  contentType: string // 内容类型，如 "/json;charset=utf-8"
  deviceIP: string // 设备 IP 地址，如 "10.66..115"
  appChannel: string // 应用渠道，可能为空
  appPlatform: string // 应用平台，可能为空
  appVersion: string // 应用版本，如 "16.1"
  deviceID: string // 设备 ID，如 "--477B-B4AE-CF7A0FCCA59A"
  language: string // 语言类型，可能为空
}
interface State {
  userInfo: UserInfo
  nativeInfo: User
  token: string
  header: RequestHeaders
}
export const useUserStore = defineStore({
  id: 'user',
  state: (): State => ({
    userInfo: {
      token: 'session_e5aca4f5321b466e', // pro session_7de50bdc7291ada4
      langType: 'cn',
      useData: {}
    },
    nativeInfo: {
      stationCode: 'PH33000001'
    },
    token: '',
    header: {
      language: 'cn',
      authToken: ''
    } as RequestHeaders
  }),
  actions: {
    setUserInfo(userInfo: UserInfo) {
      this.userInfo = userInfo
    },
    setNativeInfo(info: User) {
      this.nativeInfo = info
    },
    setToken(value: string) {
      this.token = value
    },
    setHeader(value: RequestHeaders) {
      this.header = value
    }
  },
  persist: true
})
